import { FF, useSplitFlags } from 'modules/feature-flags';
import { logger } from 'modules/logger';
import { useEffect, useState } from 'react';
import equals from 'ramda/es/equals';
import { DEPLOY_ENV } from 'config';

export const useGetCurrentUserFeatureFlagsDev = (): Nullable<{
  [x: string]: string;
}> => {
  // @ts-expect-error [EN-7967] - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'FeatureFlag[]'.
  const [loadedFlags] = useSplitFlags(Object.keys(FF));

  // Only updates when a change in flags is detected
  const [flags, setFlags] = useState(null);

  useEffect(() => {
    if (!equals(flags, loadedFlags)) {
      // @ts-expect-error [EN-10263] - TS2345 - Argument of type '{ [x: string]: string; } | null | undefined' is not assignable to parameter of type 'SetStateAction<null>'.
      setFlags(loadedFlags);
    }
  }, [flags, loadedFlags]);

  // Log the feature flags in non-production environments, if available
  useEffect(() => {
    if (flags != null && DEPLOY_ENV !== 'production') {
      logger.info('current user feature flags:', flags);
    }
  }, [flags]);

  return flags;
};

const useGetCurrentUserFeatureFlagsProd = () => {};

export const useGetCurrentUserFeatureFlags:
  | (() => void)
  | (() => Nullable<{
      [x: string]: string;
    }>) =
  DEPLOY_ENV !== 'production'
    ? useGetCurrentUserFeatureFlagsDev
    : useGetCurrentUserFeatureFlagsProd;
